import axios from "axios";

import { adminUrl, PAGES } from "../config/constants";

const checkResetEmail = (values) => async (dispatch, getState) => {
  dispatch({
    type: "SET_LOADING",
    payload: true,
  });

  dispatch({
    type: "SET_RESET_PASSWORD",
    payload: values.email,
  });

  dispatch({
    type: "RESET_PWD_ERROR",
    payload: false,
  });

  const formData = new FormData();

  formData.append("action", "checkResetEmail");
  formData.append("email", values.email);

  const { data } = await axios.post(adminUrl, formData);

  dispatch({
    type: "SET_LOADING",
    payload: false,
  });

  if (data.result === 0) {
    dispatch({
      type: "RESET_PWD_ERROR",
      payload: true,
    });

    return;
  }

  dispatch({
    type: "SET_PWD_ID",
    payload: data.id,
  });

  dispatch({
    type: "SET_PAGE",
    payload: PAGES.RESET_PASS_2,
  });
};

export default checkResetEmail;



// WEBPACK FOOTER //
// ./src/actions/checkResetEmail.actions.js